import React, { Component } from 'react';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';
import StyledReactTable from 'components/molecules/StyledReactTable';
import CellDiv from 'components/molecules/tables/components/CellDiv';

const ChannelDisplayMap = {
    ctv: 'ATV',
    audio: 'Audio',
    display: 'Display',
    mobile: 'Mobile',
    native: 'Native',
    video: 'Video',
};

class CrossChannelDataTable extends Component {
    constructor(props) {
        super(props);
        this.xChannelTableInstance = React.createRef();
    }

    getColumns() {
        return [
            {
                Header: 'Channel',
                accessor: 'channel',
                maxWidth: 300,
                style: {
                    'white-space': 'unset',
                    fontWeight: 'bold'
                },
                Cell: (props) => {
                    const tempArray = props.value.split(',').map(channel => ChannelDisplayMap[channel]).join(', ');
                    return tempArray;
                },
            }, {
                Header: 'Channel Count',
                accessor: 'channel_count',
                style: { 'white-space': 'unset' },
                maxWidth: 100,
                Cell: props => <CellDiv value={props.value} type="number" style={{ textAlign: 'right' }} />,
            }, {
                Header: 'Channel Type',
                accessor: 'channel_type',
                style: { 'white-space': 'unset' },
                Cell: props => props.value.split('-').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join('-'),
            }, {
                Header: 'Households',
                accessor: 'households',
                maxWidth: 100,
                style: { 'white-space': 'unset' },
                Cell: props => <CellDiv value={props.value} type="number" style={{ textAlign: 'right' }} />,
            }, {
                Header: 'Converters',
                accessor: 'converters',
                maxWidth: 100,
                style: { 'white-space': 'unset' },
                Cell: props => <CellDiv value={props.value} type="number" style={{ textAlign: 'right' }} />,
            }, {
                Header: 'Conversion Rate',
                accessor: 'conversion_rate',
                maxWidth: 100,
                style: { 'white-space': 'unset' },
                Cell: props => <CellDiv value={props.value} type="percentage" style={{ textAlign: 'right' }} />,
            }
        ];
    }

    render() {
        const data = this.props.data;
        return (
            <ContentTile padding={helpers.contentPadding('table')}>
                <ContentHeader tableData={data} exportName={'lab-atv-xchannel'} type={'table'}>CROSS-CHANNEL CONVERSION DATA</ContentHeader>
                <StyledReactTable
                    data={data}
                    ref={this.xChannelTableInstance}
                    pageSize={data.length}
                    getTheadThProps={() => ({
                        style: {
                            backgroundColor: '#E2E2E2',
                        }
                    })}
                    columns={this.getColumns()}
                    defaultSorted={[{
                        id: 'channel_count', desc: true
                    }]}
                    className="-highlight"
                    showPagination={false}
                />
            </ContentTile>
        );
    }
}

export default CrossChannelDataTable;



// WEBPACK FOOTER //
// ./src/components/molecules/tables/labs/ATVDataTable.js